<div class="sidenavTitleBar">
  <div style="width: 100%;">
    <h2>{{title}}</h2>

    <p class="sidenavInfo">
      <ng-content select="[buttonInfo]"></ng-content>
    </p>

  </div>
  <button mat-icon-button matTooltip="Chiudi" aria-label="Example icon-button with a heart icon" (click)="onCloseClick()" class="closeSidenavBtn">
    <mat-icon>close</mat-icon>
  </button>
</div>
